import AltexStar from "@components/Icons/AltexStar";
import getConfig from "next/config";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();
const isBricoStore = websiteName === "bricostore";

const getStoreAvailabilityProductQuantityLabel = (quantity) => {
  let label = undefined;
  let textColor = undefined;

  if (isBricoStore) {
    if (quantity >= 6) {
      label = `Stoc suficient (${quantity} buc)`;
      textColor = "text-green";
    } else if (quantity > 2) {
      label = `Cantitate redusa (${quantity} buc)`;
      textColor = "text-orange";
    } else if (quantity === 2) {
      label = `Ultimul produs sigilat (${quantity} buc)`;
      textColor = "text-orange";
    } else if (quantity === 1) {
      label = `Produs expus in magazin (${quantity} buc)`;
      textColor = "text-orange";
    } else {
      label = "Produsul nu este in stoc";
      textColor = "text-red-brand";
    }
  } else {
    if (quantity >= 6) {
      label = "Stoc suficient";
      textColor = "text-green";
    } else if (quantity > 2) {
      label = "Cantitate redusa";
      textColor = "text-orange";
    } else if (quantity === 2) {
      label = "Ultimul produs sigilat";
      textColor = "text-orange";
    } else if (quantity === 1) {
      label = "Produs expus in magazin";
      textColor = "text-orange";
    } else {
      label = "Produsul nu este in stoc";
      textColor = "text-red-brand";
    }
  }

  return { label, textColor };
};

const StoreStockStatus = ({ quantity }) => {
  // A store the product has no stock in is missing from the availability
  // payload, so it reaches this component without a qty.
  const { label, textColor } = getStoreAvailabilityProductQuantityLabel(
    quantity ?? 0
  );

  if (!label) {
    return null;
  }

  return (
    <div className={`flex items-center gap-[4px] font-medium ${textColor}`}>
      <AltexStar width="12px" height="12px" />
      {label}
    </div>
  );
};

export default StoreStockStatus;
